import React, { useRef } from "react";
export function Error({ size = 20, color = "#FF7576" }) {
    const maskid = useRef("mask_" + Math.random().toString(36).substr(2, 9));
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", height: size, width: size },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: maskid.current, fill: "#fff" },
                React.createElement("path", { d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm.5 9.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1A.5.5 0 0 0 9 12v-1a.5.5 0 0 0-.5-.5zm0-7h-1A.5.5 0 0 0 7 4v4a.5.5 0 0 0 .5.5h1A.5.5 0 0 0 9 8V4a.5.5 0 0 0-.5-.5z" })),
            React.createElement("path", { fill: color, d: "M0 16h16V0H0z", mask: `url(#${maskid.current})` }))));
}
